import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const CreateSKPRBAC = {
  pageID: '8dff529900f53d49b1fc6f291f21e397',
  elementID: {
    ViewCreateSKP: '3895eb30d6af45e089b0ca601e2cfc42',
  },
} as const

export const useCreateSKPRBAC = createUseRBAC(CreateSKPRBAC.elementID)

export type UseCreateSKPRBACType = ReturnType<typeof useCreateSKPRBAC>

export const DuplicateSKPRBAC = {
  pageID: 'f2caf7f61db7abc5a23e791df4f0e4f9',
  elementID: {
    ViewDuplicateSKP: '1ddc2916373e61322991c2be6691a352',
  },
} as const

export const useDuplicateSKPRBAC = createUseRBAC(DuplicateSKPRBAC.elementID)

export type UseDuplicateSKPRBACType = ReturnType<typeof useDuplicateSKPRBAC>

export const ViewDetailSKPRBAC = {
  pageID: '6f3de3aca09b358ac98c2a792f571997',
  elementID: {
    ViewDetailSKP: '3b28405728e416583773ec9f80d490d8',
    AddSKPDetail: 'f30fb7404c101734a1295d45d19e6488',
    UploadSKPDetail: '7536aee32a4e8c859945c825cc9df8dc',
  },
} as const

export const useViewDetailSKPRBAC = createUseRBAC(ViewDetailSKPRBAC.elementID)

export type UseViewDetailSKPRBACType = ReturnType<typeof useViewDetailSKPRBAC>

// SKP List Sourcing RBAC
export const SKPListSourcingRBAC = {
  pageID: '3a0ca40329da9031eb4cde81301e1607',
  elementID: {
    ViewSKPListSourcing: '362ae6f86cb7f038d4cb2151d9fa7a2b',
    UploadButtonSKP: '07d7ad6717984fdd73a6b51b410dfe6c',
    CreateNewSKPButton: '030124b6c8c86e160174e1de044e0057',
  },
} as const

export const useSKPListSourcingRBAC = createUseRBAC(SKPListSourcingRBAC.elementID)

export type UseSKPListSourcingRBACType = ReturnType<typeof useSKPListSourcingRBAC>

// SKP List Finance RBAC
export const SKPListFinanceRBAC = {
  pageID: '5f97d2a5ffeaaefe6eca965ffe936861',
  elementID: {
    ViewSKPListFinance: '5ef06be2ffe06df15309b34ed7db9676',
    ActionFinanceReopen: 'e61f82f3df08dfd703ff72e16c3659fc',
    ActionFinanceArchive: 'db026d99f4eb6d91eb0f8518f4d5d59b',
    ActionFinanceDownload: '16602b55feafd28c5091844a0b54e90f',
    ActionFinanceViewDetail: '5e72295b025f6b1c90b239e0caae8bdf',
  },
} as const

export const useSKPListFinanceRBAC = createUseRBAC(SKPListFinanceRBAC.elementID)

export type UseSKPListFinanceRBACType = ReturnType<typeof useSKPListFinanceRBAC>

// SKP Finance Details RBAC
export const SKPFinanceDetailsRBAC = {
  pageID: '3f59188417cd378c786714649dedfb5e',
  elementID: {
    ViewSKPFinanceHeader: '7b157734874c206929b8fd54c5270d47',
    ViewSKPFinanceTables: 'd6c6270df3c99b1f1f1067bf8011cbcf',
    ApproveRejectSKPFinance: 'dce1931659a2bd918d982595bcb98359',
    UploadClaimSKPFinance: 'de8bad2109dae5c40067d8577530ac2a',
  },
} as const

export const useSKPFinanceDetailsRBAC = createUseRBAC(SKPFinanceDetailsRBAC.elementID)

export type UseSKPFinanceDetailsRBACType = ReturnType<typeof useSKPFinanceDetailsRBAC>

// SKP List Campaign RBAC
export const SKPListCampaignRBAC = {
  pageID: 'aef55531e76d853778b9814964ba4127',
  elementID: {
    ViewSKPListCampaign: '72f50e1c9cacbd62b0e63941e296a40f',
    ActionCampaignDownload: '58795a022dffd357eceab036b82d873f',
    ActionCampaignViewDetail: 'd8127ed57a62e33fff527a2be32d1a4f',
  },
} as const

export const useSKPListCampaignRBAC = createUseRBAC(SKPListCampaignRBAC.elementID)
export type UseSKPListCampaignRBACType = ReturnType<typeof useSKPListCampaignRBAC>

// SKP List Campaign Details RBAC
export const SKPCampaignDetailsRBAC = {
  pageID: '6d5ed781f6d779a795504fbd66982f78',
  elementID: {
    ViewSKPCampaign: '6607b47f915142d9bfcc2e52ed44f7b3',
    ViewSKPCampaignTable: 'bca24faecdffe1bedeaafb59cebd1cb7',
  },
} as const

export const useSKPCampaignDetailsRBAC = createUseRBAC(SKPCampaignDetailsRBAC.elementID)

export type UseSKPCampaignDetailsRBACType = ReturnType<typeof useSKPCampaignDetailsRBAC>

export const SyaratKetentuanRBAC = {
  pageID: '00bea63795f3bb1f2efd7a1bf6d31dc2',
  elementID: {
    ViewSyaratKetentuanPage: '2e781c859870ca4a1b19d9d03dd65df5',
    EditSyaratKetentuan: 'fa7fae9cfc13067ccbef19720822f63d',
    AddSyaratKetentuan: 'fd41f783be89dabfa3013e4b5d878a56',
    DeleteSyaratKetentuan: '272b5dd4438822ea2c0b57711ce9c9d2',
  },
} as const

export const useSyaratKetentuanRBAC = createUseRBAC(SyaratKetentuanRBAC.elementID)

export type UseSyaratKetentuanRBACType = ReturnType<typeof useSyaratKetentuanRBAC>

// Internal SKP List RBAC
export const InternalSKPListRBAC = {
  pageID: '4ffb90c84782c1bcb1a3e0e5ec3535dc',
  elementID: {
    ViewDetailInternalSKP: 'ed4dc1aca3db42d69d8e4cae0ab5503b',
    EditInternalSKP: '0f075771382cb1db14390fed34303c67',
    DuplicateInternalSKP: '164b4a683794b13b67cffb1abdc9ab8e',
    DeleteInternalSKP: 'b8312145518b30a5d59f674d787a0964',
    ArchiveInternalSKP: 'db6bdd308b5637f0c009f13ec45e7595',
    ReopenInternalSKP: 'aef1566f17f8b5f853309025d5978aba',
    DownloadInternalSKP: '67dfb28bd98b9ea12436b43ebf7448bb',
    AddInternalSKPButton: '584b83b950efc542f7b2aaefd921c210',
  },
} as const

export const useInternalSKPListRBAC = createUseRBAC(InternalSKPListRBAC.elementID)

export type UseInternalSKPListRBACType = ReturnType<typeof useInternalSKPListRBAC>

// Create/Edit/Duplicate Internal SKP RBAC
export const CreateInternalSKPRBAC = {
  pageID: '898fe5ab83adbb63f67705bc87712164',
  elementID: {
    CreateInternalSKP: 'fe76e2d6e160893fa7309862b078ea3f',
  },
} as const

export const useCreateInternalSKPRBAC = createUseRBAC(CreateInternalSKPRBAC.elementID)

export type UseCreateInternalSKPRBACType = ReturnType<typeof useCreateInternalSKPRBAC>

// Internal SKP Detail RBAC
export const InternalSKPDetailRBAC = {
  pageID: '8d710e74e8060a50e7ece5e3f3130cbf',
  elementID: {
    ViewPage: 'b9ea690e591da630448ba65f0e9828d9',
    AddItem: '09b1ee7b990428598c9c4fc533a1a999',
    ApproveReject: '7cf84f4e293a8c2baf148ab7c9fed823',
    Submit: 'b9766ed9210413a202e29f4b0038139f',
    DownloadItem: '0541729870590652b80d0eb0b5333a3e',
  },
} as const

export const useInternalSKPDetailRBAC = createUseRBAC(InternalSKPDetailRBAC.elementID)

export type UseInternalSKPDetailRBACType = ReturnType<typeof useInternalSKPDetailRBAC>
